

const NotificationModel = Backbone.Model.extend({

  urlRoot: '/notifications',

});

export default NotificationModel;


